import { makeStyles } from "@mui/styles";
import React from "react";

export default function Index({ indexChild, children }) {
  return <div>{children[indexChild] ? children[indexChild] : children}</div>;
}
